import React from "react";
import dataPanel from "../../../service/dataPanel.json";
import CheckUnckeck from "../../../utility/templete/checkUnckeck";
const PanelFeatures = () => {
  return (
    <div>
      <div className="text-center text-bold" style={{ fontSize: "30px" }}>
        امکانات پنل سایه بان
      </div>
      <div className="row text-center col-md-12 ">
        {dataPanel.panelFeatures.map((p, i) => (
          <div className="row col-md-2  mt-3">
            <CheckUnckeck value={1} title={p.title} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PanelFeatures;
